export const openCompanySidebar = {
  methods: {
    openCompanySidebar(id) {
      if (id && !this.$route.query.hasOwnProperty('company')) {
        this.$router.push({
          query: { 
            ...this.$route.query,
            company: id
          },
        });
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-company');
        }, 0)
      } else if (id && this.$route.query.hasOwnProperty('company') && +this.$route.query.company !== id) {
        let routeData = this.$router.resolve({
          path: '/companies',
          query: { 
            company: id
          },
        });
        window.open(routeData.href, '_blank');
      }
    },
  }
}